// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"aea23857","879":"e6a71c9a"}[chunkId] + ".chunk.js";
};